module.exports = __webpack_public_path__ + "static/media/Fresh_Honey_TH2.5aca7920.png";